module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-07.c6529c27.svg";